var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.32 19.27-4.69-.74c-1.48-.23-2.62-.64-3.47-1.24-2.19-1.52-2.06-4.13-1.78-5.96l.74-4.69c.68-4.3 2.9-5.91 7.2-5.24l4.69.74c2.21.35 5.18 1.24 5.37 4.97.04.64 0 1.37-.14 2.23l-.73 4.69c-.58 3.67-2.29 5.39-5.46 5.39-.54 0-1.11-.05-1.73-.15zM3.6 6.88l-.74 4.69c-.46 2.95.38 3.95 1.16 4.5.66.47 1.59.79 2.84.98l4.69.74c3.49.55 4.93-.5 5.48-4l.73-4.69c.12-.75.16-1.38.12-1.91v-.01c-.11-2.1-1.3-3.13-4.11-3.57l-4.68-.73c-.58-.09-1.09-.13-1.56-.13-2.38 0-3.46 1.21-3.93 4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.76 22.2-4.51-1.5c-2.57-.85-3.96-2.07-4.38-3.85-.07-.3.05-.62.31-.79.26-.17.6-.17.85.01.66.47 1.58.79 2.83.98l4.69.74c3.49.55 4.93-.5 5.48-4l.73-4.69c.12-.75.16-1.38.12-1.91-.01-.26.12-.52.35-.67a.74.74 0 0 1 .76-.03c2.68 1.43 3.39 3.72 2.23 7.22l-1.5 4.51c-.71 2.12-1.64 3.42-2.94 4.07-.63.31-1.32.46-2.1.46-.85 0-1.81-.18-2.92-.55zm-4.04-2.92 4.51 1.5c1.72.57 2.95.62 3.87.17.92-.46 1.62-1.48 2.19-3.2l1.5-4.51c.82-2.48.5-3.8-.45-4.69-.02.25-.06.51-.1.79l-.73 4.69c-.68 4.3-2.9 5.91-7.2 5.25l-4.69-.74c-.31-.06-.61-.12-.89-.18.48.32 1.12.63 1.99.92zM5.75 7.23c0-1.37 1.12-2.49 2.49-2.49s2.49 1.12 2.49 2.49-1.12 2.49-2.49 2.49S5.75 8.6 5.75 7.23zm1.5.01c0 .55.44.99.99.99.54 0 .99-.44.99-.99s-.45-.99-.99-.99-.99.44-.99.99z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineClipboard);
export default __webpack_public_path__ + "static/media/vuesax-outline-clipboard.ef53e2ddfa7f88fbd7f12c16da988dde.svg";
export { ForwardRef as ReactComponent };